/**
 * Local storage ID key.
 */
export const LOCAL_STORAGE_ID_KEY = 'localStorageId';
/**
 * Key for the stored session.
 */
export const SESSION_KEY = 'pico_session';
/**
 * Key for the stored user infos.
 */
export const USER_INFO_KEY = 'pico_user_info';
//# sourceMappingURL=constants.js.map